import * as React from 'react';
import styled from 'styled-components';
import { useQuery } from 'urql';

import Loader from '../../../shared/components/Loader';
import t from '../../../shared/translations';
import { TeamScanStatusType } from '../../../shared/types';
import Error from '../../components/Error';
import { OList, PaddedLeft } from '../stylings';
import TeamScanBox from './TeamScanBox';

const teamScansQuery = `
    query {
        teamScanList {
            id
            status
            reportDatetime
            progress
            myLink
            submittedTaskVariant {
                id
                submittedTask {
                    id
                    learningPathItem {
                        id
                        learningPath {
                            id
                            pathname
                        }
                    }
                }
            }
        }
    }
`;

export interface ITeamScan {
    id: string;
    status: TeamScanStatusType;
    reportDatetime: string | null;
    progress: [number, number];
    myLink: string;
    submittedTaskVariant: {
        id: string;
        submittedTask: {
            id: string;
            learningPathItem: {
                id: string;
                learningPath: {
                    id: string;
                    pathname: string;
                };
            } | null;
        };
    } | null;
}

interface IData {
    teamScanList: ITeamScan[];
}

interface IWrapper {
    $center?: boolean;
}

const Wrapper = styled.div<IWrapper>`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: ${({ $center }) => $center ? 'center' : 'flex-start'};
    flex-grow: 1;
`;

function Landing(): JSX.Element {
    const [result] = useQuery<IData>({
        query: teamScansQuery,
    });

    if (result.fetching) {
        return <Loader />;
    } else if (result.error) {
        return <Error />;
    }

    const showIntro = result.data.teamScanList.length === 1 && result.data.teamScanList[0].status === 'setup-survey';

    return <>
        <h1>{t('player.team-scan-landing.heading')}</h1>
        {showIntro && <PaddedLeft>
            <p>{t('player.team-scan-landing.info-process-steps')}</p>
            <OList>
                <li>{t('player.team-scan-landing.info-process-step-1')}</li>
                <li>{t('player.team-scan-landing.info-process-step-2')}</li>
                <li>{t('player.team-scan-landing.info-process-step-3')}</li>
            </OList>
        </PaddedLeft>}
        <Wrapper $center={!showIntro}>
            {result.data.teamScanList.map(tq => <TeamScanBox key={tq.id} teamScan={tq} />)}
        </Wrapper>
    </>;
}

export default Landing;
